import { EndpointOption } from '../traffic-history.models';

export function buildEndpointOptions(endpointKeys: Array<string | null>): EndpointOption[] {
  const unique = Array.from(new Set(endpointKeys));

  return unique.map((key, index) => ({
    key,
    label: key === null ? 'Consolidado' : `Enlace ${index + 1}`,
  }));
}

export function resolveDefaultEndpointKey(options: EndpointOption[]): string | null | undefined {
  if (options.length === 0) return undefined;
  if (options.length === 1) return options[0].key;
  return undefined;
}
